import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-24 px-6 bg-cream relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-radial from-gold-200/20 to-transparent rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-radial from-gold-200/20 to-transparent rounded-full translate-x-1/2 translate-y-1/2"></div>
      
      <div className="max-w-7xl mx-auto relative">
        <div className="text-center mb-16">
          <span className="font-montserrat text-xs tracking-super-wide text-gold-600 uppercase">Why Choose Family</span>
          <h2 className="font-playfair text-5xl md:text-6xl text-charcoal mt-4 mb-6">
            The Master Jewelers Difference
          </h2>
          <div className="w-24 h-px bg-gradient-gold mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <p className="font-cormorant text-2xl text-charcoal/90 leading-relaxed">
              When you choose Master Jewelers, you're not just buying jewelry, you're investing 
              in three generations of family tradition, where every custom engagement ring and 
              bespoke piece is crafted right here in our workshop, not outsourced to distant factories.
            </p>
            
            <p className="font-montserrat text-charcoal/70 leading-relaxed">
              As a family-owned business, we operate without the markups of chain stores. 
              Our master craftsmen specialize in custom design, 
              vintage designs, and trending cuts like oval, emerald, halo, and pear shaped diamonds. 
              From personalized jewelry and engraving services to while-you-wait repairs, every 
              creation comes with our family's lifetime guarantee.
            </p>

            <div className="grid grid-cols-2 gap-8 mt-12">
              <div className="text-center">
                <div className="font-playfair text-5xl text-gold-500 mb-2">30+</div>
                <div className="font-montserrat text-sm text-charcoal/60 uppercase tracking-wider">Years of Excellence</div>
              </div>
              <div className="text-center">
                <div className="font-playfair text-5xl text-gold-500 mb-2">5000+</div>
                <div className="font-montserrat text-sm text-charcoal/60 uppercase tracking-wider">Masterpieces Created</div>
              </div>
            </div>

            <div className="mt-12">
              <h3 className="font-playfair text-2xl text-charcoal mb-6">The Family Advantage</h3>
              <ul className="space-y-4">
                {[
                  'Custom engagement rings with natural and lab grown diamonds',
                  'Trending cuts: oval, emerald, halo, pear shaped, and marquise diamonds',
                  'Personalized jewelry and engraving services for special occasions',
                  'While-you-wait repairs - ring sizing, watch batteries, jewelry cleaning',
                  'Bespoke jewelry design for anniversaries, graduations, and holidays',
                  'Lifetime warranty on all custom engagement rings and jewelry'
                ].map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <span className="text-gold-500 mt-1">✦</span>
                    <span className="font-montserrat text-charcoal/70">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="relative">
            <div className="relative overflow-hidden rounded-sm shadow-2xl gold-shimmer">
              <div className="aspect-w-4 aspect-h-5 bg-gradient-to-br from-charcoal to-charcoal/90">
                <div className="flex items-center justify-center">
                  <div className="text-center p-12">
                    <div className="text-gold-400 text-6xl mb-6">♦</div>
                    <p className="font-cormorant text-xl text-white italic mb-6 leading-relaxed">
                      "For over forty years, I've been hand-crafting one-of-a-kind treasures for my customers. Every piece is unique, handmade, and created in-house by me. You can purchase with confidence knowing it was made by my hands."
                    </p>
                    <div className="font-playfair text-gold-400 text-xl">Ray</div>
                    <div className="font-montserrat text-white/60 text-sm tracking-wider uppercase mt-1">
                      Master Craftsman
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Decorative frame corners */}
            <div className="absolute -top-4 -left-4 w-16 h-16 border-t-2 border-l-2 border-gold-400"></div>
            <div className="absolute -top-4 -right-4 w-16 h-16 border-t-2 border-r-2 border-gold-400"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 border-b-2 border-l-2 border-gold-400"></div>
            <div className="absolute -bottom-4 -right-4 w-16 h-16 border-b-2 border-r-2 border-gold-400"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;